import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./GestionClientes.css";

const GestionClientes = () => {
    const [clientes, setClientes] = useState([]);
    const [nuevoCliente, setNuevoCliente] = useState({
        nombre: "",
        direccion: "",
        ciudad: "",
        telefono: "",
        vendedor: "",
        precio_domicilio: 0.0,
    });
    const [editingCliente, setEditingCliente] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [clienteToDelete, setClienteToDelete] = useState(null);

    // Obtener clientes al cargar el componente
    useEffect(() => {
        fetchClientes();
    }, []);

    // Obtener todos los clientes
    const fetchClientes = async () => {
        try {
            const response = await axios.get("https://backend-vbfh.onrender.com/api/clientes");
            setClientes(response.data);
        } catch (error) {
            console.error("Error al obtener clientes:", error);
        }
    };

    // Manejar cambios en los inputs del formulario
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (editingCliente) {
            setEditingCliente({ ...editingCliente, [name]: value });
        } else {
            setNuevoCliente({ ...nuevoCliente, [name]: value });
        }
    };

    // Crear o actualizar un cliente
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editingCliente) {
                await axios.put(`https://backend-vbfh.onrender.com/api/clientes/${editingCliente.id}`, editingCliente);
                setEditingCliente(null);
            } else {
                console.log("Datos del nuevo cliente:", nuevoCliente); // Verifica los datos antes de enviar
                await axios.post("https://backend-vbfh.onrender.com/api/clientes", nuevoCliente);
            }
            fetchClientes();
            setShowForm(false);
            setNuevoCliente({ nombre: "", direccion: "", ciudad: "", telefono: "", vendedor: "", precio_domicilio: 0.0 });
        } catch (error) {
            console.error("Error al guardar el cliente:", error.response ? error.response.data : error); // Verifica la respuesta del servidor
        }
    };

    // Eliminar un cliente
    const handleDeleteCliente = async (id) => {
        try {
            await axios.delete(`https://backend-vbfh.onrender.com/api/clientes/${id}`);
            fetchClientes();
            setShowDeleteModal(false);
        } catch (error) {
            console.error("Error al eliminar el cliente:", error);
        }
    };

    // Editar un cliente
    const handleEditCliente = (cliente) => {
        setEditingCliente(cliente);
        setShowForm(true);
    };

    // Filtrar clientes por término de búsqueda
    const filteredClientes = clientes.filter((cliente) =>
        cliente.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        cliente.ciudad.toLowerCase().includes(searchTerm.toLowerCase()) ||
        cliente.vendedor.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="gestion-clientes-container">
            <h2>Gestión de Clientes</h2>

            {/* Campo de búsqueda */}
            <input
                type="text"
                placeholder="Buscar cliente por nombre, ciudad o vendedor..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
            />

            {/* Botón para mostrar el formulario */}
            <button onClick={() => { setShowForm(true); setEditingCliente(null); }} className="add-button">
                {showForm ? "Cancelar" : "Añadir Cliente"}
            </button>

            {/* Formulario para añadir o editar clientes */}
            {showForm && (
                <form onSubmit={handleSubmit} className="cliente-form">
                    <input
                        type="text"
                        name="nombre"
                        placeholder="Nombre"
                        value={editingCliente ? editingCliente.nombre : nuevoCliente.nombre}
                        onChange={handleInputChange}
                        required
                    />
                    <input
                        type="text"
                        name="direccion"
                        placeholder="Dirección"
                        value={editingCliente ? editingCliente.direccion : nuevoCliente.direccion}
                        onChange={handleInputChange}
                        required
                    />
                    <input
                        type="text"
                        name="ciudad"
                        placeholder="Ciudad"
                        value={editingCliente ? editingCliente.ciudad : nuevoCliente.ciudad}
                        onChange={handleInputChange}
                        required
                    />
                    <input
                        type="text"
                        name="telefono"
                        placeholder="Teléfono"
                        value={editingCliente ? editingCliente.telefono : nuevoCliente.telefono}
                        onChange={handleInputChange}
                        required
                    />
                    <input
                        type="text"
                        name="vendedor"
                        placeholder="Vendedor"
                        value={editingCliente ? editingCliente.vendedor : nuevoCliente.vendedor}
                        onChange={handleInputChange}
                        required
                    />
                    <input
                        type="number"
                        name="precio_domicilio"
                        placeholder="Precio del Domicilio"
                        value={editingCliente ? editingCliente.precio_domicilio : nuevoCliente.precio_domicilio}
                        onChange={handleInputChange}
                        required
                    />
                    <button type="submit" className="save-button">
                        {editingCliente ? "Actualizar Cliente" : "Guardar Cliente"}
                    </button>
                    <button
                        type="button"
                        onClick={() => {
                            setShowForm(false);
                            setNuevoCliente({ nombre: "", direccion: "", ciudad: "", telefono: "", vendedor: "", precio_domicilio: 0.0 });
                            setEditingCliente(null);
                        }}
                        className="cancel-button"
                    >
                        Cancelar
                    </button>
                </form>
            )}

            {/* Lista de clientes */}
            <div className="clientes-list">
                {filteredClientes.map((cliente) => (
                    <div key={cliente.id} className="cliente-card">
                        <div className="cliente-info">
                            <h3>{cliente.nombre}</h3>
                            <p><strong>Dirección:</strong> {cliente.direccion}</p>
                            <p><strong>Ciudad:</strong> {cliente.ciudad}</p>
                            <p><strong>Teléfono:</strong> {cliente.telefono}</p>
                            <p><strong>Vendedor:</strong> {cliente.vendedor}</p>
                            <p><strong>Precio del Domicilio:</strong> ${cliente.precio_domicilio}</p>
                        </div>
                        <div className="cliente-actions">
                            <button onClick={() => handleEditCliente(cliente)}>Editar</button>
                            <button onClick={() => { setClienteToDelete(cliente.id); setShowDeleteModal(true); }}>Eliminar</button>
                        </div>
                    </div>
                ))}
            </div>

            {/* Modal de confirmación para eliminar cliente */}
            {showDeleteModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h3>¿Estás seguro de eliminar este cliente?</h3>
                        <div className="modal-actions">
                            <button onClick={() => setShowDeleteModal(false)}>Cancelar</button>
                            <button onClick={() => handleDeleteCliente(clienteToDelete)}>Eliminar</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Botón para volver al panel de administración */}
            <Link to="/admin" className="back-button">
                Volver al Panel de Administración
            </Link>
        </div>
    );
};

export default GestionClientes;